import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { CancelationConfirmationModal } from './CancelationConfirmationModal';

export const CancelationButton = ({
  bookingRequestId,
  onHidden,
  ...rest
}: { bookingRequestId: string; onHidden: () => void } & Parameters<typeof Button>[0]) => {
  const [show, setShow] = useState(false);

  const handleClose = (result) => {
    setShow(false);

    if (result) {
      onHidden();
    }
  };
  const handleShow = () => setShow(true);

  return (
    <>
      <CancelationConfirmationModal
        bookingRequestId={bookingRequestId}
        show={show}
        onHide={handleClose}
      />
      <Button variant="danger" {...rest} onClick={handleShow}>
        Cancel Assignment
      </Button>
    </>
  );
};
